import { Controller } from "@hotwired/stimulus"
import { string } from "prop-types"

/* Connects to data-controller="drawer"
 *
 * Usage:
 * <div data-controller="drawer" data-drawer-identifier-value="some-identifier" id="some-identifier-drawer">
 *   <button data-action="drawer#open">Open</button>
 *   <%= render DrawerComponent.new(heading: "some-identifier") do %>
 *     <div data-controller="drawer--touched" data-drawer--touched-identifier-value="some-identifier">
 *       <!-- any clicks in here will trigger a "touched" which will prevent closing the drawer -->
 *       <p>Hello</p>
 * 
 *        <!-- You can skip the close check by adding the data-drawer--touched-close-param="force" attribute -->
 *     </div>
 *   <% end %>  
 * </div>
 *
 * Notes:
 * - The drawer component must be inside the drawer controller's element
 * - The drawer component's heading must match the heading value
 * - The DrawerComponent loads with a drawer-instance controller which
 *   will respond to the dispatched event and open the drawer
 * - The drawer--touched controller is used to determine if the drawer
 *   should be opened when the drawer-touched controller is clicked
 */

export default class extends Controller {
  static values = {
    identifier: String
  }

  open() {
    event.preventDefault();
    this.dispatch("open", { detail: { instance: this.identifierValue }})
  }
}
